"use strict";
/**
 * Created by Hovhannes.Sahakyan
 * on 7/13/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var DisplayType;
(function (DisplayType) {
    DisplayType[DisplayType["FIELDS"] = 0] = "FIELDS";
    DisplayType[DisplayType["FUNCTIONAL"] = 1] = "FUNCTIONAL";
})(DisplayType = exports.DisplayType || (exports.DisplayType = {}));
var ValidationDisplay = /** @class */ (function () {
    function ValidationDisplay() {
    }
    ValidationDisplay.fromResponse = function (response) {
        if (!response) {
            return null;
        }
        var validationDisplay = new ValidationDisplay();
        validationDisplay.displayType = DisplayType[response.displayType];
        if (response.displayData instanceof Array) {
            validationDisplay.displayData = new Map([
                ['fields', response.displayData],
            ]);
        }
        else {
            var entries = Object.keys(response.displayData).map(function (k) { return [k, response.displayData[k]]; });
            validationDisplay.displayData = new Map(entries);
        }
        return validationDisplay;
    };
    Object.defineProperty(ValidationDisplay.prototype, "displayType", {
        get: function () {
            return this._displayType;
        },
        set: function (value) {
            this._displayType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationDisplay.prototype, "displayData", {
        get: function () {
            return this._displayData;
        },
        set: function (value) {
            this._displayData = value;
        },
        enumerable: true,
        configurable: true
    });
    return ValidationDisplay;
}());
exports.ValidationDisplay = ValidationDisplay;
//# sourceMappingURL=validation-display.model.js.map